import React, { Component, useEffect, useState } from "react";
import {
  Collapse,
  Container,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";
import { Link } from "react-router-dom";
import "./NavMenu.css";
import { postData, getData, patchData, deleteData } from "../../util/Fetch";
import swal from "sweetalert";
import Button from "@mui/material/Button";
import { useHistory } from "react-router-dom";

const NavMenu = (props) => {
  const history = useHistory();
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {}, [props]);

  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    postData("Login/Logout", {}).then((res) => {
      if (res === true) {
        swal("登出成功", "已順利登出帳號", "success").then((res) => {
          history.push("/");
        });
      }
    });
  };

  return (
    <header>
      <Navbar
        className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3"
        light
      >
        <Container>
          <NavbarBrand tag={Link} to="/">
            預約管理後台
          </NavbarBrand>
          <NavbarToggler onClick={toggleNavbar} className="mr-2" />
          <Collapse
            className="d-sm-inline-flex flex-sm-row-reverse"
            isOpen={collapsed}
            navbar
          >
            <ul className="navbar-nav flex-grow">
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/service">
                  服務管理
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/eventCalander">
                  行事曆
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/editProfile">
                  個人資料修改
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/bill">
                  業績明細
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink tag={Link} className="text-dark" to="/salary">
                  薪資紀錄
                </NavLink>
              </NavItem>
              <NavItem>
                <Button onClick={handleLogout}>登出</Button>
              </NavItem>
            </ul>
          </Collapse>
        </Container>
      </Navbar>
    </header>
  );
};

export default NavMenu;
